import { render, staticRenderFns } from "./widget_opiniones_curso_avanzado.vue?vue&type=template&id=dfc92c2a&scoped=true&"
import script from "./widget_opiniones_curso_avanzado.vue?vue&type=script&lang=js&"
export * from "./widget_opiniones_curso_avanzado.vue?vue&type=script&lang=js&"
import style0 from "./widget_opiniones_curso_avanzado.vue?vue&type=style&index=0&id=dfc92c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc92c2a",
  null
  
)

export default component.exports